import { ChangeDetectionStrategy, Component, computed, effect, inject, signal } from '@angular/core';
import { MatSlideToggle, MatSlideToggleChange } from '@angular/material/slide-toggle';

import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { filter, tap } from 'rxjs';

import { PpDialogService } from '@pp/core/services';
import { ShellStore } from '@pp/shell';

import { ConfirmToggleAgentAccountSalesComponent } from '../confirm-toggle-agent-account-sales/confirm-toggle-agent-account-sales.component';

@Component({
  selector: 'pp-toggle-agent-account-sales',
  imports: [MatSlideToggle, TranslateModule],
  templateUrl: './toggle-agent-account-sales.component.html',
  styleUrl: './toggle-agent-account-sales.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ToggleAgentAccountSalesComponent {
  readonly #shellStore = inject(ShellStore);
  readonly #ppDialogService = inject(PpDialogService);
  readonly #translate = inject(TranslateService);

  loaded = computed(() => typeof this.enable() === 'boolean');
  enable = signal(false);

  appSettingsEffect = effect(() => {
    const settings = this.#shellStore.appSettings();
    if (settings) {
      this.enable.set(settings.agent_feature_availability);
    }
  });

  switch(event: MatSlideToggleChange): void {
    const enableMode = event.checked;
    const title = this.enable() ? 'shell.header.salesToggle.enable.title' : 'shell.header.salesToggle.disable.title';

    event.source.checked = this.enable();

    this.#ppDialogService
      .open<ConfirmToggleAgentAccountSalesComponent, { enableMode: boolean }>({
        title: this.#translate.instant(title),
        components: [ConfirmToggleAgentAccountSalesComponent],
        data: { enableMode },
      })
      .afterClosed()
      .pipe(
        filter(Boolean),
        tap(() => this.enable.set(enableMode)),
      )
      .subscribe();
  }
}
